export const SCHEDULE_DEFAULT_ICON = 'calendar-days';
